import { FaqAccordion } from '@/organisms/FaqAccordion'
import { Faq } from '@/types/codegen-contentful'

type FaqSectionProps = {
  faqs: Faq[]
}
export const FaqSection = ({ faqs }: FaqSectionProps) => {
  if (!faqs) return null

  return (
    <div className="w-full px-6 lg:max-w-6xl lg:px-0">
      <FaqAccordion
        faqs={faqs}
        showTopBorder={true}
        labelClassName={''}
        borderColor={'core-gray-300'}
        contentClassName={'text-core-gray-700 !photon-paragraph-md !leading-7'}
        shouldDefaultOpen={true}
        headingClassName={'text-center'}
      />
    </div>
  )
}
